import request from "root/js/request";

export const getSPPList = async ({
  date_from,
  date_to,
  ordering,
  limit,
  offset,
  product_id,
  ...rest
}) => {
  const response = await request({
    url: `/monitoring/wb_user_product_spp_history/`,
    method: "get",
    params: {
      limit,
      offset,
      ordering,
      product_id,
      date_from,
      date_to,
      ...rest,
    },
  });
  return response.data;
};

export const getSPPUserNotification = async ({ limit, offset, ...rest }) => {
  const response = await request({
    url: `monitoring/spp_user_notification/`,
    method: "get",
    params: {
      limit,
      offset,
      ...rest,
    },
  });
  return response.data;
};
export const getSppLimitsMonitoring = async () => {
  const response = await request({
    url: `monitoring/spp_user_notification/limits/`,
    method: "get",
    params: {},
  });
  return response.data;
};
